import { useAuthContext } from '../../contexts/AuthContext';
import { useLazyQuery, useMutation, useQuery, useSubscription } from '@apollo/client';
// import { getAgendaUser } from './queries';

import Spinner from 'react-bootstrap/Spinner';
import Carousel from 'react-bootstrap/Carousel';
import { Button, Card, Col, Container, Row, Image, Modal, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import CustomModal from '../../components/Modals/CustomModal';

function DetailScreen() {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  const userId = AuthUserId;
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          const yOffset = -100; // ajuste selon la hauteur de ton header ou ton H1
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
          // element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    }

    const scrollOffset = 200;
    const scrollElement = document.querySelector(".js-scroll"); // fading container
    const logoScrollElement = document.querySelector(".slide_logo"); // logo animation

    const elementInView = (el: any, offset = 0) => {
      if (!el) return false;
      const elementTop = el.getBoundingClientRect().top;
      return elementTop <= (window.innerHeight - offset);
    };

    const displayScrollElement = () => scrollElement?.classList.add("scrolled");
    const hideScrollElement = () => scrollElement?.classList.remove("scrolled");
    const handleScrollAnimation = () => {
      if (elementInView(scrollElement, scrollOffset)) {
        displayScrollElement();
      } 
    };

    const displayLogoScrollElement = () => logoScrollElement?.classList.add("scrolled");
    
    const handleLogoAnimation = () => {
      if (elementInView(logoScrollElement, 0)) {
        displayLogoScrollElement();
      }
    };

    const onScroll = () => {
      handleScrollAnimation(); // fading container
      handleLogoAnimation(); // logo animation
    };
    // console.log("logoScrollElement found:", logoScrollElement);

    window.addEventListener("scroll", onScroll);

    // return () => {
    //   window.removeEventListener("scroll", onScroll);
    // };
  const queryString = window.location.search; // Ex: "?missingCompanyLink"
  const query = queryString.substring(1); // Supprime le "?"
  // console.log(query);

  if (query == "missingCompanyLink") {
    setContentModal(<>
      <Modal.Header closeButton>
        <Modal.Title>{t('dashboard.linkedCompanyTitle')}</Modal.Title>
      </Modal.Header>
        
      <Modal.Body>
        <p>{t('dashboard.linkedCompany')}</p>
      </Modal.Body></>);
    // setLinkModal('/');
    setShowCustomModal(true);
  }

  document.title = t('title.details');
}, []);


  // const {data, loading, error, refetch} = useQuery(getAgendaUser, {variables: {userId: userId}});

  // if (loading) {// || loadingShift || loadingRequest) {
  //   return (
  //     <Spinner animation="border" role="status">
  //       <span className="visually-hidden">Loading...</span>
  //     </Spinner>
  //   )
  // };

  
  // const items = [
//     {
//       src: 'https://picsum.photos/id/123/1200/400',
//       altText: 'Slide 1',
//       caption: 'Slide 1',
//       key: 1,
//     },
//     {
//       src: 'https://picsum.photos/id/456/1200/400',
//       altText: 'Slide 2',
//       caption: 'Slide 2',
//       key: 2,
//     },
//     {
//       src: 'https://picsum.photos/id/678/1200/400',
//       altText: 'Slide 3',
//       caption: 'Slide 3',
//       key: 3,
//     },
//   ];
  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <div className="blackTop"><h1>{t('detail.title')}</h1></div>
      <Container id="rh" fluid className="homeCardContainer">
        <Container className="d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <h2 className="h1 bg_gradient_text" style={{color: '#FFF' }} >{t('detail.rhTitle')}</h2>
          <p style={{color: '#FFF', textAlign: 'center' }}>{t('detail.rhMessage')}</p>
        </Container>
        <Container className="justify-content-md-center mt-5 w-100 pb-5" style={{textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
          <h4>
            <Link className="free-trial p-3" to="/help" style={{color: 'white', textDecoration: 'none', backgroundColor: "maroon"}}>
              {t('homepage.help_video')}
            </Link>
          </h4>
        </Container>
        <Row className="g-4 justify-content-center" style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
            <Card className="w-100">
              {/* <Card className="mb-4" style={{ width: '400px' }}> */}
              <Card.Img variant="top" src="/phones/scheduler.png" alt={t('image.scheduler')} />
              {/* <Card.Body className="bg-secondary text-white"> */}
              <Card.Body>
                {/* <Card.Title>{t('homepage.card.hr')}</Card.Title> */}
                <Card.Title style={{textAlign: 'center'}}>{t('detail.timeTitle')}</Card.Title>
                <Card.Text><p dangerouslySetInnerHTML={{ __html: t('detail.timeMessage') }} /></Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
            <Card className="w-100">
              {/* <Card className="mb-4" style={{ width: '400px' }}> */}
              <Card.Img variant="top" src="/phones/card_gps.png" alt={t('image.punch_gps')}/>
              {/* <Card.Body className="bg-secondary text-white"> */}
              <Card.Body>
                {/* <Card.Title>{t('homepage.card.hr')}</Card.Title> */}
                <Card.Title style={{textAlign: 'center'}}>{t('detail.rhGPSTitle')}</Card.Title>
                  <Card.Text><p dangerouslySetInnerHTML={{ __html: t('detail.rhGPSMessage') }} /></Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
            <Card className="w-100">
              {/* <Card className="mb-4" style={{ width: '400px' }}> */}
              <Card.Img variant="top" src="/phones/upload_table.png" alt={t('image.upload_table')} />
              {/* <Card.Body className="bg-secondary text-white"> */}
              <Card.Body>
                {/* <Card.Title>{t('homepage.card.hr')}</Card.Title> */}
                <Card.Title style={{textAlign: 'center'}}>{t('detail.rhSpreadsheetTitle')}</Card.Title>    
                  <Card.Text><p dangerouslySetInnerHTML={{ __html: t('detail.rhSpreadsheetMessage') }} /></Card.Text> 
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Container className="justify-content-md-center mt-5 w-100 pb-5" style={{textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
          <h4>
            <Link className="free-trial p-3" to="/signup" style={{color: 'white', textDecoration: 'none'}}>
              {t('homepage.try_free')}
            </Link>
          </h4>
        </Container>
      </Container>
      <Container fluid className="banner-container">
        <div style={{position: 'relative', flex: 'none'}} >
          <div className="waveGapTop"></div>
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ transform: 'scaleY(-1)' }}>
              <path fill="#b0b3f7" fill-opacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
        </div>
        {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-bottom-image" style={{marginTop: '-1px'}} /> */}
      </Container>
      {/* { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center" style={{ paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
          <h1 style={{color: '#BBB' }} >Schedulum</h1>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center" style={{marginTop: '-280px', marginBottom: '220px', position: 'relative'}}>
          <h1 style={{color: 'white' }} >Schedulum</h1>
        </Container>
      } */}
      
      {/* { !(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && */}
      { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/ios_scheduler_400.png" className="home_phones" alt={t('image.scheduler')} loading="lazy"/></li>
              <li><img src="/phones/ios_agenda_400.png" className="home_phones" alt={t('image.agenda')} loading="lazy"/></li>
              <li><img src="/phones/ios_request_400.png" className="home_phones" alt={t('image.request')} loading="lazy"/></li>
              <li><img src="/phones/ios_leave_400.png" className="home_phones" alt={t('image.leave')} loading="lazy"/></li>
              <li><img src="/phones/ios_post_400.png" className="home_phones" alt={t('image.posts')} loading="lazy"/></li>
          </ul>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/ios_scheduler_400.png" className="home_phones" alt={t('image.scheduler')} loading="lazy"/></li>
              <li><img src="/phones/ios_agenda_400.png" className="home_phones" alt={t('image.agenda')} loading="lazy"/></li>
              <li><img src="/phones/ios_request_400.png" className="home_phones" alt={t('image.request')} loading="lazy"/></li>
              <li><img src="/phones/ios_leave_400.png" className="home_phones" alt={t('image.leave')} loading="lazy"/></li>
              <li><img src="/phones/ios_post_400.png" className="home_phones" alt={t('image.posts')} loading="lazy"/></li>
          </ul>
        </Container>
      }

      <Container fluid className="card-container" >
        <div style={{position: 'relative', flex: 'none'}} >
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#b0b3f7" fill-opacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
          <div className="waveGapBottom"></div>
        </div>
        {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-top-image" style={{marginBottom: '-1px'}}/> */}

        <Container id="time" fluid className="homeCardContainer" style={{ paddingTop: '40px', paddingBottom: '40px' }}>    
          <Container className="d-flex flex-column justify-content-center align-items-center" style={{paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <h2 className="h1" style={{ color: '#FFF' }}>{t('detail.statTitle')}</h2>
            <p style={{ color: '#FFF' }}>{t('detail.statMessage')}</p>
          </Container>
          <Container className="justify-content-md-center mt-5 w-100 pb-5" style={{textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
            <h4>
              <Link className="free-trial p-3" to="/help" style={{color: 'white', textDecoration: 'none', backgroundColor: "maroon"}}>
                {t('homepage.help_video')}
              </Link>
            </h4>
          </Container>
          <Row className="g-4 justify-content-center" style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/AI/boxplot.png" alt={t('image.boxplot')} loading="lazy" />
                <Card.Body>
                  <Card.Title className="text-center">{t('detail.boxplotTitle')}</Card.Title>
                  <Card.Text>
                    <p dangerouslySetInnerHTML={{ __html: t('detail.boxplotMessage') }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '380px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/AI/barplot.png" alt={t('image.barplot')} loading="lazy"/>
                <Card.Body>
                  <Card.Title className="text-center">{t('detail.barplotTitle')}</Card.Title>
                  <Card.Text>
                    <p dangerouslySetInnerHTML={{ __html: t('detail.barplotMessage') }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '380px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/AI/heatmap.png" alt={t('image.heatmap')} loading="lazy"/>
                <Card.Body>
                  <Card.Title className="text-center py-4">{t('detail.heatmapTitle')}</Card.Title>
                  <Card.Text>
                    <p dangerouslySetInnerHTML={{ __html: t('detail.heatmapMessage') }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '380px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/AI/ai_recommendation.png" alt={t('image.ai_recommandation')} loading="lazy"/>
                <Card.Body>
                  <Card.Title className="text-center py-4">{t('detail.recommendationTitle')}</Card.Title>
                  <Card.Text>
                    <p dangerouslySetInnerHTML={{ __html: t('detail.recommendationMessage') }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '380px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/AI/spyder_radar.png" alt={t('image.spyder_radar')} loading="lazy"/>
                <Card.Body>
                  <Card.Title className="text-center">{t('detail.spyderradarTitle')}</Card.Title>
                  <Card.Text>
                    <p dangerouslySetInnerHTML={{ __html: t('detail.spyderradarMessage') }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <div className="text-center mt-5 pb-5" style={{ color: 'white' }}>
            <h4>
              <Link className="free-trial p-3" to="/signup" style={{ color: 'white', textDecoration: 'none' }}>
                {t('homepage.try_free')}
              </Link>
            </h4>
          </div>
        </Container>
        <Container fluid className="banner-container">
          <div style={{position: 'relative', flex: 'none'}} >
            <div className="waveGapTop"></div>
            <div id="wave-container" >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" style={{ transform: 'scaleY(-1)' }}>
                <path fill="#b0b3f7" fill-opacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
                </path>
              </svg>
            </div>
          </div>
          {/* <img src="/home/roundedTopBorder200light.png" alt="Banner" className="curved-bottom-image" style={{marginTop: '-1px'}} /> */}
          {/* <Container className="d-flex justify-content-center align-items-center" style={{marginTop: '-280px', marginBottom: '220px', position: 'relative'}}>
            <h1 style={{color: 'white' }} >Schedulum</h1>
          </Container> */}
        </Container>
      </Container>

      { (/iPhone|iPod|Android|BlackBerry|IEMobile/i.test(navigator.userAgent)) ?
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/ios_desktop_400.png" className="home_phones" alt={t('image.desktop')} loading="lazy"/></li>
              <li><img src="/phones/ios_document_400.png" className="home_phones" alt={t('image.document')} loading="lazy"/></li>
              <li><img src="/phones/ios_sidebar_400.png" className="home_phones" alt={t('image.options')} loading="lazy"/></li>
              <li><img src="/phones/ios_map_400.png" className="home_phones" alt={t('image.posts')} loading="lazy"/></li>
              <li><img src="/phones/ios_swapShift_400.png" className="home_phones"alt={t('image.swap')} loading="lazy"/></li>
          </ul>
        </Container>
      :
        <Container className="d-flex justify-content-center align-items-center position-relative">
          {/* <ul className="ai_logo slide_logo js-logo-scroll slide-left"> */}
          <ul className="ai_logo slide_logo js-logo-scroll slide-left d-flex flex-wrap justify-content-center">
              {/* <li><img src="/ai_logo/anthropic.png"/></li>
              <li><img src="/ai_logo/Llama.png"/></li>
              <li><img src="/ai_logo/openai.png"/></li>
              <li><img src="/ai_logo/cohere_black.png"/></li>
              <li><img src="/ai_logo/AI21.png"/></li> */}
              <li><img src="/phones/ios_desktop_400.png" className="home_phones" loading="lazy"/></li>
              <li><img src="/phones/ios_document_400.png" className="home_phones" loading="lazy"/></li>
              <li><img src="/phones/ios_sidebar_400.png" className="home_phones" loading="lazy"/></li>
              <li><img src="/phones/ios_map_400.png" className="home_phones" loading="lazy"/></li>
              <li><img src="/phones/ios_swapShift_400.png" className="home_phones" loading="lazy" /></li>
          </ul>
        </Container>
      }

      <Container fluid className="card-container" >
        <div style={{position: 'relative', flex: 'none'}} >
          <div id="wave-container" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path fill="#b0b3f7" fill-opacity="1" d="M0,160L48,160C96,160,192,160,288,176C384,192,480,224,576,218.7C672,213,768,171,864,133.3C960,96,1056,64,1152,48C1248,32,1344,32,1392,32L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z">
              </path>
            </svg>
          </div>
          <div className="waveGapBottom"></div>
        </div>
        
        <Container id="communication" fluid className="homeCardContainer">
          <Container className="d-flex flex-column justify-content-center align-items-center" style={{paddingTop: '20px', marginBottom: '20px', position: 'relative'}}>
            <h2 className="h1" style={{color: 'white' }} >{t('detail.communicationTitle')}</h2>
            <p style={{color: 'white' }}>{t('detail.communicationMessage')}</p>
          </Container>
          <Container className="justify-content-md-center mt-5 w-100 pb-5" style={{textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
            <h4>
              <Link className="free-trial p-3" to="/help" style={{color: 'white', textDecoration: 'none', backgroundColor: "maroon"}}>
                {t('homepage.help_video')}
              </Link>
            </h4>
          </Container>
          <Row className="g-4 justify-content-center" style={{ display: 'flex', flexWrap: 'wrap' }}>
            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/phones/com_posts.png" alt={t('image.com_posts')} loading="lazy"/>
                <Card.Body>
                  <Card.Title style={{ textAlign: 'center'}}>{t('detail.comPostTitle')}</Card.Title>
                  <Card.Text><p dangerouslySetInnerHTML={{ __html: t('detail.comPostMessage')}} /></Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/phones/com_leave_request.png" alt={t('image.com_leave_requests')} loading="lazy"/>
                <Card.Body>
                  <Card.Title style={{ textAlign: 'center'}}>{t('detail.comLeaveTitle')}</Card.Title>
                  <Card.Text><p dangerouslySetInnerHTML={{ __html: t('detail.comLeaveMessage')}} /></Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} sm={6} md={4} lg={3} className="d-flex justify-content-center" style={{ flex: '1 1 25%', minWidth: '350px' }}>
              <Card className="w-100">
                <Card.Img variant="top" src="/phones/com_swap_request.png" alt={t('image.com_swap_requests')} loading="lazy"/>
                <Card.Body>
                  <Card.Title style={{ textAlign: 'center'}}>{t('detail.comSwapTitle')}</Card.Title>
                  <Card.Text><p dangerouslySetInnerHTML={{ __html: t('detail.comSwapMessage') }} /></Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Container className="justify-content-md-center mt-5 w-100 pb-5" style={{textAlign: 'center', justifyContent: 'center', zIndex:100, color: 'white'}}>
            <h4>
              <Link className="free-trial p-3" to="/signup" style={{color: 'white', textDecoration: 'none'}}>
                {t('homepage.try_free')}
              </Link>
            </h4>
          </Container>
        </Container>
      </Container>
    </>
   
  );
}

export default DetailScreen;